module.exports = __webpack_public_path__ + "img/pic4-2.1f45c915.png";